import React from "react";
import PublicLayout from "../../../../layouts/user/PublicLayout";
import BeritaPopuler from "../../../../components/user/posts/BeritaPopuler";
import CardVideo from "../../../../components/user/galeri/video/CardVideo";

function Video() {
	return (
		<PublicLayout title="Galeri Video" subtitle="Video kegiatan madrasah">
			<div className="flex flex-col lg:flex-row gap-8">
				<div className="w-full lg:w-[68%]">
					<CardVideo />
				</div>
				<div className="w-full lg:w-[30%]">
					<BeritaPopuler />
				</div>
			</div>
		</PublicLayout>
	);
}

export default Video;
